import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { validatePerimetersFiles } from '../utils/validate-perimeters-files'

export function useValidatePerimeterFiles() {
  const mutation = useMutation({
    mutationFn: validatePerimetersFiles,
    onError: (err: any) => toast.error(err.message),
  })

  return mutation
}
